import fetch from 'isomorphic-fetch';

interface FetchReveal {
    advertId: number;
    revealSellerTelephoneNumberToken: string;
    redirectToApp: string;
    skipLoginToReveal?: boolean;
}

export const fetchOptions = (revealSellerTelephoneNumberToken, redirectToApp) => ({
    method: 'GET',
    headers: {
        'X-GUMTREE-TOKEN': revealSellerTelephoneNumberToken,
        'content-type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        ...redirectToApp !== '' && {'X-APP-OPT': redirectToApp}
    },
});

const fetchReveal = async ({ advertId, revealSellerTelephoneNumberToken, redirectToApp, skipLoginToReveal }: FetchReveal) => {
    const url = skipLoginToReveal ? `/ajax/motors/reveal/number/${advertId}` : `/ajax/account/seller/reveal/number/${advertId}`;
    return await fetch(url, fetchOptions(revealSellerTelephoneNumberToken, redirectToApp));
}

export default fetchReveal;
